const domain = 'https://tokens.app.pulsex.com'

const getTokenLogoURL = (address: string) => `${domain}/images/tokens/${address}.png`

export default getTokenLogoURL
